

// ##############################################

// Pull Mechanism

// import React, { useMemo, useRef, useState, useEffect, useImperativeHandle } from "react"; // ⬅️ UPDATED IMPORTS
// import PropTypes from "prop-types";
// import Card from "@mui/material/Card";
// import CircularProgress from "@mui/material/CircularProgress";
// import Grow from "@mui/material/Grow";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import EntityCard from "examples/Cards/EntityCard";
// import MetricCardsContainer from "./MetricCardsContainer";
// import ContentToolbar from "./ContentToolbar";
// import EntityDetailsPopup from "layouts/components/EntityDetailsPopup";

// const INITIAL_RENDER_COUNT = 10;
// const LOAD_MORE_BATCH_SIZE = 10;
// // Define a maximum number of entities to render on the static report/PDF
// const MAX_REPORT_ENTITIES = 500; 
// // const DEBOUNCE_TIME_MS = 300; // No longer needed for continuous push

// // 🎯 UPDATED: Wrap the component in forwardRef to accept a ref from the parent
// const ContentChart = React.forwardRef(({ title, datasets, previousdatasets, isLoading, onConfigChange }, ref) => {
// // Note: onConfigChange is kept in props for PropTypes but is now ignored internally.
// // State for filtering and sorting
// const [searchQuery, setSearchQuery] = useState("");
// const [sortOption, setSortOption] = useState("date");
// const [sortDirection, setSortDirection] = useState("desc");
// const [filterOption, setFilterOption] = useState("all");

// // Existing states
// const imageHeightsRef = useRef([]);
// const [heightCalculationDone, setHeightCalculationDone] = useState(false);
// const [entityDataReady, setEntityDataReady] = useState(false);
// const [allEntities, setAllEntities] = useState([]);
// const [renderCount, setRenderCount] = useState(INITIAL_RENDER_COUNT);
// const [loading, setLoading] = useState(false);

// // ✅ Details popup state
// const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
// const [selectedEntity, setSelectedEntity] = useState(null);

// // ✅ Handler to show analytics modal
// const handleViewAnalytics = (entity) => {
//  setSelectedEntity(entity);
//  setIsDetailsModalOpen(true);
// };
// const handleDetailsModalClose = () => {
//  setIsDetailsModalOpen(false);
//  setSelectedEntity(null);
// };

// const registerHeight = (height) => {
//  imageHeightsRef.current.push(Math.round(height));
//  if (imageHeightsRef.current.length === allEntities.length) {
//  setHeightCalculationDone(true);
//  }
// };

// const forcedHeight = useMemo(() => {
//  if (!heightCalculationDone) return 250;
//  const counts = {};
//  imageHeightsRef.current.forEach((h) => {
//  counts[h] = (counts[h] || 0) + 1;
//  });
//  const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1]);
//  const MAX_ALLOWED_HEIGHT = 300;
//  return sorted.length > 0 ? Math.min(Number(sorted[0][0]), MAX_ALLOWED_HEIGHT) : 250;
// }, [heightCalculationDone]);

// useEffect(() => {
//  if (!datasets || datasets.length === 0) {
//  setAllEntities([]);
//  return;
//  }

//  setLoading(true);
//  setHeightCalculationDone(false);
//  setEntityDataReady(false);
//  imageHeightsRef.current = [];
//  setRenderCount(INITIAL_RENDER_COUNT);

//  const entities = datasets.flatMap((profile) => {
//  const contentField = profile.platform === "YouTube" ? "videos" : "posts";
//  const entityType = profile.platform === "YouTube" ? "video" : "post";
//  const contentArray = profile.data.flatMap((entry) => entry[contentField] || []);

//  return contentArray.map((content) => ({
//   ...content,
//   profile,
//   type: entityType,
//  }));
//  });

//  setAllEntities(entities);
//  setEntityDataReady(true);
//  setTimeout(() => setHeightCalculationDone(true), 0);
//  setLoading(false);
// }, [datasets]);

// const filteredAndSortedEntities = useMemo(() => {
//  let tempEntities = [...allEntities];

//  // Filtering Logic
//  if (filterOption !== "all") {
//  tempEntities = tempEntities.filter(
//   (entity) => entity.post_type === filterOption ||
//     entity.video_type === filterOption ||
//     entity.media_type === filterOption ||
//     (!entity.post_type && !entity.video_type && !entity.media_type && entity.type === filterOption)
//  );
//  }

//  // Search Logic
//  if (searchQuery) {
//  const lowercasedQuery = searchQuery.toLowerCase();
//  tempEntities = tempEntities.filter((entity) => {
//   const title = entity.title || entity.description || entity.caption || entity.message || "";
//   return title.toLowerCase().includes(lowercasedQuery);
//  });
//  }

//  // Helper function to get reaction count (only likes and emotion-based reactions)
//  const getReactionCount = (entity) => {
//  // Instagram/Facebook posts
//  if (entity.postMetrics) {
//   return (
//   (entity.postMetrics.like || 0) +
//   (entity.postMetrics.likes || 0) +
//   (entity.postMetrics.love || 0) +
//   (entity.postMetrics.wow || 0) +
//   (entity.postMetrics.haha || 0) +
//   (entity.postMetrics.sad || 0) +
//   (entity.postMetrics.angry || 0)
//   );
//  }
//  // YouTube videos
//  if (entity.videoMetrics) {
//   return entity.videoMetrics.likeCount || 0;
//  }
//  // Fallback for other platforms
//  return entity.like_count || 0;
//  };

//  // Helper function to get total interactions count
//  const getTotalInteractionsCount = (entity) => {
//  // Instagram/Facebook posts
//  if (entity.postMetrics) {
//   return (
//   (entity.postMetrics.like || 0) +
//   (entity.postMetrics.likes || 0) +
//   (entity.postMetrics.comments || 0) +
//   (entity.postMetrics.shares || 0) +
//   (entity.postMetrics.love || 0) +
//   (entity.postMetrics.wow || 0) +
//   (entity.postMetrics.haha || 0) +
//   (entity.postMetrics.sad || 0) +
//   (entity.postMetrics.angry || 0)
//   );
//  }
//  // YouTube videos
//  if (entity.videoMetrics) {
//   return (entity.videoMetrics.likeCount || 0) + (entity.videoMetrics.commentCount || 0) + (entity.videoMetrics.viewCount || 0);
//  }
//  // Fallback for other platforms
//  return (entity.like_count || 0) + (entity.comments_count || 0) + (entity.view_count || 0);
//  };

//  // Helper function to get followers/subscribers on a specific date
//  const getFollowersByDate = (profileData, contentDate) => {
//  if (!profileData || profileData.length === 0) {
//   return 1;
//  }
//  const contentTimestamp = new Date(contentDate).getTime();
//  const closestEntry = profileData.reduce((closest, current) => {
//   const currentTimestamp = new Date(current.date).getTime();
//   const closestTimestamp = closest ? new Date(closest.date).getTime() : -Infinity;

//   if (currentTimestamp <= contentTimestamp && (contentTimestamp - currentTimestamp) < (contentTimestamp - closestTimestamp)) {
//   return current;
//   }
//   return closest;
//  }, null);
//  return (closestEntry?.followers || closestEntry?.subscribers || 1);
//  };

//  // Sorting Logic
//  if (tempEntities.length > 0) {
//  const direction = sortDirection === "asc" ? 1 : -1;
//  tempEntities.sort((a, b) => {
//   let aValue, bValue;

//   switch (sortOption) {
//   case "date":
//    aValue = new Date(a.created_time || a.publishedAt || a.taken_at || a.date || 0).getTime();
//    bValue = new Date(b.created_time || b.publishedAt || b.taken_at || b.date || 0).getTime();
//    break;
//   case "reaction":
//    aValue = getReactionCount(a);
//    bValue = getReactionCount(b);
//    break;
//   case "engagement":
//    const aFollowers = getFollowersByDate(a.profile.data, a.created_time || a.publishedAt || a.taken_at || a.date);
//    const bFollowers = getFollowersByDate(b.profile.data, b.created_time || b.publishedAt || b.taken_at || b.date);

//    const aTotalInteractions = getTotalInteractionsCount(a);
//    const bTotalInteractions = getTotalInteractionsCount(b);

//    aValue = aTotalInteractions / aFollowers;
//    bValue = bTotalInteractions / bFollowers;
//    break;
//   default:
//    return 0;
//   }
//   return (aValue - bValue) * direction;
//  });
//  }

//  return tempEntities;
// }, [allEntities, searchQuery, filterOption, sortOption, sortDirection]);

// const filterOptions = useMemo(() => {
//  const uniqueTypes = new Set();
//  allEntities.forEach(entity => {
//  if (entity.post_type) {
//   uniqueTypes.add(entity.post_type);
//  }
//  if (entity.video_type) {
//   uniqueTypes.add(entity.video_type);
//  }
//  if (entity.media_type) {
//   uniqueTypes.add(entity.media_type);
//  }
//  // For other content types, we can use the 'type' field from the flattening process
//  if (!entity.post_type && !entity.video_type && !entity.media_type) {
//   uniqueTypes.add(entity.type);
//  }
//  });
//  return ["all", ...Array.from(uniqueTypes)];
// }, [allEntities]);

// useEffect(() => {
//  if (renderCount < filteredAndSortedEntities.length) {
//  const timeout = setTimeout(() => {
//   setRenderCount((prev) => Math.min(prev + LOAD_MORE_BATCH_SIZE, filteredAndSortedEntities.length));
//  }, 500);
//  return () => clearTimeout(timeout);
//  }
// }, [renderCount, filteredAndSortedEntities.length]);

// const contentMetrics = useMemo(() => {
//  const filteredCounts = {};
//  // Add a check to ensure entity.profile exists before trying to access profileId
//  filteredAndSortedEntities.forEach(entity => {
//  if (entity.profile) {
//   const profileId = entity.profile.profileId;
//   filteredCounts[profileId] = (filteredCounts[profileId] || 0) + 1;
//  }
//  });

//  // Flatten and filter the previous datasets for consistent counting
//  const previousFilteredEntities = previousdatasets?.flatMap(profile => {
//  const contentField = profile.platform === "YouTube" ? "videos" : "posts";
//  return profile.data.flatMap(entry => entry[contentField] || []).map(content => ({ ...content, profile })).filter(entity => {
//   if (filterOption === "all") return true;
//   const entityType = entity.post_type || entity.video_type || (entity.profile.platform === "YouTube" ? "video" : "post");
//   return entityType === filterOption;
//  });
//  }) || [];

//  const previousFilteredCounts = {};
//  previousFilteredEntities.forEach(entity => {
//  if (entity.profile) {
//   const profileId = entity.profile.profileId;
//   previousFilteredCounts[profileId] = (previousFilteredCounts[profileId] || 0) + 1;
//  }
//  });


//  return datasets.map((profile) => {
//  const currentFilteredCount = filteredCounts[profile.profileId] || 0;
//  const previousFilteredCount = previousFilteredCounts[profile.profileId] || 0;

//  return {
//   profilePic: profile.profilePictureUrl || "https://via.placeholder.com/150",
//   name: profile.name || profile.label || "Unknown",
//   platform: profile.platform,
//   metricName: "Content Count",
//   metricValue: currentFilteredCount.toLocaleString(),
//   previousMetricValue: previousFilteredCount.toLocaleString(),
//  };
//  });
// }, [datasets, previousdatasets, filteredAndSortedEntities, filterOption]);

//   // 1. Calculate the raw config object
//  const rawChartConfig = useMemo(() => {
//   // Extract a unique ID for each entity that is currently visible in the filtered/sorted list
//   const entityIdOrder = filteredAndSortedEntities
//    .slice(0, MAX_REPORT_ENTITIES) // Apply the cap here!
//    .map(entity => entity.postId || entity.id || entity.videoId || entity.permalink_url);

//     // 🎯 DEBUG LOG 1: Check the generated ID list
//     console.log(`[ContentChart] Memo: Filtered entities count = ${filteredAndSortedEntities.length}`);
//     console.log(`[ContentChart] Memo: entityIdOrder generated (first 5):`, entityIdOrder.slice(0, 5));

//   return {
//    searchQuery,
//    sortOption,
//    sortDirection,
//    filterOption,
//    // Pass the final, ordered list of IDs to the backend
//    entityIdOrder,
//   };
//  }, [filteredAndSortedEntities, searchQuery, sortOption, sortDirection, filterOption]);


//  // 2. 🛑 REMOVED: The problematic useEffect that was sending continuous updates is gone!
//  // We will now expose a function to return the config on demand.

//  // 3. ✅ NEW: Expose the rawChartConfig via useImperativeHandle
//  useImperativeHandle(ref, () => ({
//   getCurrentConfig: () => rawChartConfig,
//  }));


// // ⏳ Loader during fetch
// if (isLoading) {
// // ... [Rendering code is unchanged from here down] ...
//  return (
//  <Card>
//   <MDBox p={3} display="flex" justifyContent="center" alignItems="center" height="250px">
//   <CircularProgress size={32} thickness={4} color="accent"/>
//   </MDBox>
//  </Card>
//  );
// }

// if (!datasets) {
//  return (
//  <Card>
//   <MDBox p={3} textAlign="center">
//   <MDTypography variant="body2" color="text">
//    No content data available.
//   </MDTypography>
//   </MDBox>
//  </Card>
//  );
// }

// return (
// <>

//  <Card
//  sx={{
//  display: "flex",
//  flexDirection: "column",
//  // no fixed height: let it shrink or grow,
//  // but don't allow more than 2 rows (~650–700px) to show
//  }}
//  >
//  <MDBox
//  mx={2}
//  mt={-3}
//  py={1}
//  px={2}
//  variant="gradient"
//  bgColor="info"
//  borderRadius="lg"
//  coloredShadow="info"
//  display="flex"
//  alignItems="center"
//  >
//  <MDTypography variant="h6" color="white">
//  {title}
//  </MDTypography>
//  </MDBox>

//  <ContentToolbar
//  searchQuery={searchQuery}
//  setSearchQuery={setSearchQuery}
//  sortOption={sortOption}
//  setSortOption={setSortOption}
//  sortDirection={sortDirection}
//  setSortDirection={setSortDirection}
//  filterOption={filterOption}
//  setFilterOption={setFilterOption}
//  filterOptions={filterOptions}
//  />

//  <MetricCardsContainer metrics={contentMetrics} />
//  <MDBox mt={1} />

//  {/* ✅ Scrollable area for entity cards */}
//  <MDBox
//  px={2}
//  py={3}
//  sx={{
//  flexGrow: 1,
//  overflowY: "auto",
//  maxHeight: "700px", // roughly two rows including gaps
//  }}
//  >
//  {loading || !entityDataReady ? (
//  <MDBox display="flex" justifyContent="center" alignItems="center" p={3}>
//   <CircularProgress color="accent" />
//  </MDBox>
//  ) : filteredAndSortedEntities.length === 0 ? (
//  <MDTypography variant="subtitle1" color="text" align="center">
//   No content found in the selected date range.
//  </MDTypography>
//  ) : (
//  <MDBox
//   display="flex"
//   flexWrap="wrap"
//   justifyContent="center"
//   gap={2}
//   px={2}
//  >
//   {filteredAndSortedEntities.slice(0, renderCount).map((entity, index) => {
//   const id =
//   entity.postId || entity.videoId || entity.id || `content-${index}`;
//   return (
//   <Grow
//   in={true}
//   timeout={index * 50}
//   key={id}
//   style={{ transformOrigin: "0 0 0" }}
//   ><div>
//   <MDBox
//    sx={{
//    flex: "1 1 calc(20% - 16px)",
//    minWidth: "280px",
//    maxWidth: "300px",
//    }}
//   >
//    <EntityCard
//    entityObject={entity}
//    platform={entity.profile.platform}
//    entityType={entity.type}
//    profileObject={entity.profile}
//    isSelected={false}
//    onSelect={() => {}}
//    forcedHeight={forcedHeight}
//    registerHeight={registerHeight}
//    onViewAnalytics={() => handleViewAnalytics(entity)}
//    />
//   </MDBox></div>
//   </Grow>
//   );
//   })}
//  </MDBox>
//  )}
//  </MDBox>
//  </Card>

// {/* ✅ Details popup */}
// {isDetailsModalOpen && selectedEntity && (
//  <EntityDetailsPopup
//  isModalOpen={isDetailsModalOpen}
//  onClose={handleDetailsModalClose}
//  entityObject={selectedEntity}
//  />
// )}
// </>
// );
// });

// ContentChart.propTypes = {
// title: PropTypes.string.isRequired,
// datasets: PropTypes.array.isRequired,
// previousdatasets: PropTypes.array,
// isLoading: PropTypes.bool.isRequired,
// // The prop is no longer needed but kept for cleanliness if the parent expects it.
// onConfigChange: PropTypes.func, 
// };

// ContentChart.defaultProps = {
//  onConfigChange: () => {},
// };

// export default ContentChart;


// ########################################################

// // Pull Mechanism - Working Code

// import React, {
//   useMemo,
//   useRef,
//   useState,
//   useEffect,
//   useImperativeHandle,
// } from "react";
// import PropTypes from "prop-types";
// import Card from "@mui/material/Card";
// import CircularProgress from "@mui/material/CircularProgress";
// import Grow from "@mui/material/Grow";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import EntityCard from "examples/Cards/EntityCard";
// import MetricCardsContainer from "./MetricCardsContainer";
// import ContentToolbar from "./ContentToolbar";
// import EntityDetailsPopup from "layouts/components/EntityDetailsPopup";

// // ✅ Import the new header and Typography for the description
// import ChartHeader from "examples/Charts/General/ChartHeader";
// import { Typography } from "@mui/material";

// const INITIAL_RENDER_COUNT = 10;
// const LOAD_MORE_BATCH_SIZE = 10;
// const MAX_REPORT_ENTITIES = 500;

// // ✅ UPDATED: Added description and is_derived to props
// const ContentChart = React.forwardRef(
//   ({ title, description, is_derived, datasets, previousdatasets, isLoading, onConfigChange }, ref) => {
//     // Note: onConfigChange is kept in props for PropTypes but is now ignored internally.
//     // State for filtering and sorting
//     const [searchQuery, setSearchQuery] = useState("");
//     const [sortOption, setSortOption] = useState("date");
//     const [sortDirection, setSortDirection] = useState("desc");
//     const [filterOption, setFilterOption] = useState("all");

//     // Existing states
//     const imageHeightsRef = useRef([]);
//     const [heightCalculationDone, setHeightCalculationDone] = useState(false);
//     const [entityDataReady, setEntityDataReady] = useState(false);
//     const [allEntities, setAllEntities] = useState([]);
//     const [renderCount, setRenderCount] = useState(INITIAL_RENDER_COUNT);
//     const [loading, setLoading] = useState(false);

//     // ✅ Details popup state
//     const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
//     const [selectedEntity, setSelectedEntity] = useState(null);

//     // ✅ Handler to show analytics modal
//     const handleViewAnalytics = (entity) => {
//       setSelectedEntity(entity);
//       setIsDetailsModalOpen(true);
//     };
//     const handleDetailsModalClose = () => {
//       setIsDetailsModalOpen(false);
//       setSelectedEntity(null);
//     };

//     const registerHeight = (height) => {
//       imageHeightsRef.current.push(Math.round(height));
//       if (imageHeightsRef.current.length === allEntities.length) {
//         setHeightCalculationDone(true);
//       }
//     };

//     const forcedHeight = useMemo(() => {
//       if (!heightCalculationDone) return 250;
//       const counts = {};
//       imageHeightsRef.current.forEach((h) => {
//         counts[h] = (counts[h] || 0) + 1;
//       });
//       const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1]);
//       const MAX_ALLOWED_HEIGHT = 300;
//       return sorted.length > 0 ? Math.min(Number(sorted[0][0]), MAX_ALLOWED_HEIGHT) : 250;
//     }, [heightCalculationDone]);

//     useEffect(() => {
//       if (!datasets || datasets.length === 0) {
//         setAllEntities([]);
//         return;
//       }

//       setLoading(true);
//       setHeightCalculationDone(false);
//       setEntityDataReady(false);
//       imageHeightsRef.current = [];
//       setRenderCount(INITIAL_RENDER_COUNT);

//       const entities = datasets.flatMap((profile) => {
//         if (!profile) return []; // ✅ Guard for undefined profiles
//         const contentField = profile.platform === "YouTube" ? "videos" : "posts";
//         const entityType = profile.platform === "YouTube" ? "video" : "post";
//         const contentArray = (profile.data || []).flatMap((entry) => entry[contentField] || []); // ✅ Guard for undefined data

//         return contentArray.map((content) => ({
//           ...content,
//           profile,
//           type: entityType,
//         }));
//       });

//       setAllEntities(entities);
//       setEntityDataReady(true);
//       setTimeout(() => setHeightCalculationDone(true), 0);
//       setLoading(false);
//     }, [datasets]);

//     const filteredAndSortedEntities = useMemo(() => {
//       let tempEntities = [...allEntities];

//       // Filtering Logic
//       if (filterOption !== "all") {
//         tempEntities = tempEntities.filter(
//           (entity) =>
//             entity.post_type === filterOption ||
//             entity.video_type === filterOption ||
//             entity.media_type === filterOption ||
//             (!entity.post_type && !entity.video_type && !entity.media_type && entity.type === filterOption)
//         );
//       }

//       // Search Logic
//       if (searchQuery) {
//         const lowercasedQuery = searchQuery.toLowerCase();
//         tempEntities = tempEntities.filter((entity) => {
//           const title = entity.title || entity.description || entity.caption || entity.message || "";
//           return title.toLowerCase().includes(lowercasedQuery);
//         });
//       }

//       // ✅ Restored helper functions
//       const getReactionCount = (entity) => {
//         if (entity.postMetrics) {
//           return (
//             (entity.postMetrics.like || entity.postMetrics.likes || 0) +
//             (entity.postMetrics.love || 0) +
//             (entity.postMetrics.wow || 0) +
//             (entity.postMetrics.haha || 0) +
//             (entity.postMetrics.sad || 0) +
//             (entity.postMetrics.angry || 0)
//           );
//         }
//         if (entity.videoMetrics) {
//           return entity.videoMetrics.likeCount || 0;
//         }
//         return entity.like_count || 0;
//       };

//       const getTotalInteractionsCount = (entity) => {
//         if (entity.postMetrics) {
//           return (
//             (entity.postMetrics.like || entity.postMetrics.likes || 0) +
//             (entity.postMetrics.comments || 0) +
//             (entity.postMetrics.shares || 0) +
//             (entity.postMetrics.love || 0) +
//             (entity.postMetrics.wow || 0) +
//             (entity.postMetrics.haha || 0) +
//             (entity.postMetrics.sad || 0) +
//             (entity.postMetrics.angry || 0)
//           );
//         }
//         if (entity.videoMetrics) {
//           return (
//             (entity.videoMetrics.likeCount || 0) +
//             (entity.videoMetrics.commentCount || 0) +
//             (entity.videoMetrics.viewCount || 0)
//           );
//         }
//         return (
//           (entity.like_count || 0) +
//           (entity.comments_count || 0) +
//           (entity.view_count || 0)
//         );
//       };

//       const getFollowersByDate = (profileData, contentDate) => {

//         console.log("Profile Data : ", profileData);
//         if (!profileData || profileData.length === 0) {
//           return 1;
//         }
//         const contentTimestamp = new Date(contentDate).getTime();
//         const closestEntry = profileData.reduce((closest, current) => {
//           const currentTimestamp = new Date(current.date).getTime();
//           const closestTimestamp = closest
//             ? new Date(closest.date).getTime()
//             : -Infinity;
//           if (
//             currentTimestamp <= contentTimestamp &&
//             contentTimestamp - currentTimestamp <
//             contentTimestamp - closestTimestamp
//           ) {
//             return current;
//           }
//           return closest;
//         }, null);
//         return closestEntry?.followers || closestEntry?.subscribers || closestEntry?.predicted_subscribers || closestEntry?.predicted_followers || 1;
//       };

//       // Sorting Logic
//       if (tempEntities.length > 0) {
//         const direction = sortDirection === "asc" ? 1 : -1;
//         tempEntities.sort((a, b) => {
//           let aValue, bValue;
//           switch (sortOption) {
//             case "date":
//               aValue = new Date(a.created_time || a.publishedAt || a.taken_at || a.date || 0).getTime();
//               bValue = new Date(b.created_time || b.publishedAt || b.taken_at || b.date || 0).getTime();
//               break;
//             case "reaction":
//               aValue = getReactionCount(a);
//               bValue = getReactionCount(b);
//               break;
//             case "engagement":
//               const aFollowers = getFollowersByDate(a.profile.data, a.created_time || a.publishedAt || a.taken_at || a.date);
//               const bFollowers = getFollowersByDate(b.profile.data, b.created_time || b.publishedAt || b.taken_at || b.date);
//               const aTotalInteractions = getTotalInteractionsCount(a);
//               const bTotalInteractions = getTotalInteractionsCount(b);
//               aValue = aTotalInteractions / aFollowers;
//               bValue = bTotalInteractions / bFollowers;
//               break;
//             default:
//               return 0;
//           }
//           return (aValue - bValue) * direction;
//         });
//       }

//       return tempEntities;
//     }, [allEntities, searchQuery, filterOption, sortOption, sortDirection]);

//     const filterOptions = useMemo(() => {
//       const uniqueTypes = new Set();
//       allEntities.forEach((entity) => {
//         if (entity.post_type) uniqueTypes.add(entity.post_type);
//         if (entity.video_type) uniqueTypes.add(entity.video_type);
//         if (entity.media_type) uniqueTypes.add(entity.media_type);
//         if (!entity.post_type && !entity.video_type && !entity.media_type) uniqueTypes.add(entity.type);
//       });
//       return ["all", ...Array.from(uniqueTypes)];
//     }, [allEntities]);

//     useEffect(() => {
//       if (renderCount < filteredAndSortedEntities.length) {
//         const timeout = setTimeout(() => {
//           setRenderCount((prev) => Math.min(prev + LOAD_MORE_BATCH_SIZE, filteredAndSortedEntities.length));
//         }, 500);
//         return () => clearTimeout(timeout);
//       }
//     }, [renderCount, filteredAndSortedEntities.length]);

//     const contentMetrics = useMemo(() => {
//       if (!datasets) return []; // ✅ Guard
//       const filteredCounts = {};
//       filteredAndSortedEntities.forEach((entity) => {
//         if (entity.profile) {
//           const profileId = entity.profile.profileId;
//           filteredCounts[profileId] = (filteredCounts[profileId] || 0) + 1;
//         }
//       });

//       const previousFilteredEntities =
//         previousdatasets
//           ?.flatMap((profile) => {
//             if (!profile) return [];
//             const contentField = profile.platform === "YouTube" ? "videos" : "posts";
//             return (profile.data || []).flatMap((entry) => entry[contentField] || [])
//               .map((content) => ({ ...content, profile }))
//               .filter((entity) => {
//                 if (filterOption === "all") return true;
//                 const entityType = entity.post_type || entity.video_type || (entity.profile.platform === "YouTube" ? "video" : "post");
//                 return entityType === filterOption;
//               });
//           }) || [];

//       const previousFilteredCounts = {};
//       previousFilteredEntities.forEach((entity) => {
//         if (entity.profile) {
//           const profileId = entity.profile.profileId;
//           previousFilteredCounts[profileId] = (previousFilteredCounts[profileId] || 0) + 1;
//         }
//       });

//       return datasets.map((profile) => {
//         if (!profile) return null;
//         const currentFilteredCount = filteredCounts[profile.profileId] || 0;
//         const previousFilteredCount = previousFilteredCounts[profile.profileId] || 0;
//         return {
//           profilePic: profile.profilePictureUrl || "https://via.placeholder.com/150",
//           name: profile.name || profile.label || "Unknown",
//           platform: profile.platform,
//           metricName: "Content Count",
//           metricValue: currentFilteredCount.toLocaleString(),
//           previousMetricValue: previousFilteredCount.toLocaleString(),
//         };
//       }).filter(Boolean);
//     }, [datasets, previousdatasets, filteredAndSortedEntities, filterOption]);

//     const rawChartConfig = useMemo(() => {
//       const entityIdOrder = filteredAndSortedEntities
//         .slice(0, MAX_REPORT_ENTITIES)
//         .map(entity => entity.postId || entity.id || entity.videoId || entity.permalink_url);

//       return { searchQuery, sortOption, sortDirection, filterOption, entityIdOrder };
//     }, [filteredAndSortedEntities, searchQuery, sortOption, sortDirection, filterOption]);

//     useImperativeHandle(ref, () => ({
//       getCurrentConfig: () => rawChartConfig,
//     }));

//     if (isLoading) {
//       return (
//         <Card>
//           <MDBox p={3} display="flex" justifyContent="center" alignItems="center" height="250px">
//             <CircularProgress size={32} thickness={4} color="accent" />
//           </MDBox>
//         </Card>
//       );
//     }

//     if (!datasets) {
//       return (
//         <Card>
//           <MDBox p={3} textAlign="center">
//             <MDTypography variant="body2" color="text">
//               No content data available.
//             </MDTypography>
//           </MDBox>
//         </Card>
//       );
//     }

//     // ⬇️ Tooltip for chart usage
//     const tooltipContent = (
//       <div style={{ maxWidth: "350px", textAlign: "left" }}>
//         <Typography variant="body2" gutterBottom>
//           <strong>Description:</strong>
//         </Typography>
//         <Typography variant="caption" display="block" gutterBottom>
//           This component displays all individual content (posts and videos) published by the selected profiles within the chosen date range.
//         </Typography>

//         <Typography variant="body2" gutterBottom>
//           <strong>How to use this chart:</strong>
//         </Typography>
//         <Typography variant="caption" display="block" gutterBottom>
//           - Use the toolbar to filter by content type, sort by date or engagement, or search for specific keywords. <br />
//           - Click the analytics icon on any post to view its detailed performance metrics.
//         </Typography>

//         <Typography variant="body2" gutterBottom>
//           <strong>Insights you can gain:</strong>
//         </Typography>
//         <Typography variant="caption" display="block">
//           - Visually compare the content being posted by different profiles. <br />
//           - Sort by "Engagement" to quickly find the top-performing content. <br />
//           - Filter by "video" or "photo" to analyze a specific content strategy.
//         </Typography>
//       </div>
//     );

//     return (
//       <>
//         <Card sx={{ display: "flex", flexDirection: "column" }}>
//           <ChartHeader
//             title={title}
//             description={description || tooltipContent}
//             profilePictures={contentMetrics.map(m => m.profilePic)}
//             is_derived={is_derived}
//           />

//           <ContentToolbar
//             searchQuery={searchQuery}
//             setSearchQuery={setSearchQuery}
//             sortOption={sortOption}
//             setSortOption={setSortOption}
//             sortDirection={sortDirection}
//             setSortDirection={setSortDirection}
//             filterOption={filterOption}
//             setFilterOption={setFilterOption}
//             filterOptions={filterOptions}
//           />

//           <MetricCardsContainer metrics={contentMetrics} />
//           <MDBox mt={1} />

//           <MDBox px={2} py={3} sx={{ flexGrow: 1, overflowY: "auto", maxHeight: "700px" }}>
//             {loading || !entityDataReady ? (
//               <MDBox display="flex" justifyContent="center" alignItems="center" p={3}>
//                 <CircularProgress color="accent" />
//               </MDBox>
//             ) : filteredAndSortedEntities.length === 0 ? (
//               <MDTypography variant="subtitle1" color="text" align="center">
//                 No content found for this filter.
//               </MDTypography>
//             ) : (
//               <MDBox display="flex" flexWrap="wrap" justifyContent="center" gap={2} px={2}>
//                 {filteredAndSortedEntities.slice(0, renderCount).map((entity, index) => {
//                   const id = entity.postId || entity.videoId || entity.id || `content-${index}`;
//                   return (
//                     <Grow in={true} timeout={index * 50} key={id} style={{ transformOrigin: "0 0 0" }}>
//                       <div>
//                         <MDBox sx={{ flex: "1 1 calc(20% - 16px)", minWidth: "280px", maxWidth: "300px" }}>
//                           <EntityCard
//                             entityObject={entity}
//                             platform={entity.profile.platform}
//                             entityType={entity.type}
//                             profileObject={entity.profile}
//                             isSelected={false}
//                             onSelect={() => { }}
//                             forcedHeight={forcedHeight}
//                             registerHeight={registerHeight}
//                             onViewAnalytics={() => handleViewAnalytics(entity)}
//                           />
//                         </MDBox>
//                       </div>
//                     </Grow>
//                   );
//                 })}
//               </MDBox>
//             )}
//           </MDBox>
//         </Card>

//         {isDetailsModalOpen && selectedEntity && (
//           <EntityDetailsPopup
//             isModalOpen={isDetailsModalOpen}
//             onClose={handleDetailsModalClose}
//             entityObject={selectedEntity}
//           />
//         )}
//       </>
//     );
//   }
// );

// ContentChart.propTypes = {
//   title: PropTypes.string.isRequired,
//   description: PropTypes.node,
//   is_derived: PropTypes.bool,
//   datasets: PropTypes.array.isRequired,
//   previousdatasets: PropTypes.array,
//   isLoading: PropTypes.bool.isRequired,
//   onConfigChange: PropTypes.func,
// };

// ContentChart.defaultProps = {
//   onConfigChange: () => { },
//   description: null,
//   is_derived: false,
// };

// export default ContentChart;

// ################################################################################

// ########################################################

// // Pull Mechanism - Working Code

import React, {
  useMemo,
  useRef,
  useState,
  useEffect,
  useImperativeHandle,
} from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Grow from "@mui/material/Grow";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import EntityCard from "examples/Cards/EntityCard";
import MetricCardsContainer from "../components/MetricCardsContainer";
import ContentToolbar from "../components/ContentToolbar";
import EntityDetailsPopup from "layouts/components/EntityDetailsPopup";
import UpgradePopup from "layouts/components/Upgrade"; // [NEW] Import

// ✅ Import the new header and Typography for the description
import ChartHeader from "examples/Charts/General/ChartHeader";
import { Typography } from "@mui/material";

// ✅ Import ChartAssistant
import ChartAssistant from "components/ChartAssistant";

const INITIAL_RENDER_COUNT = 10;
const LOAD_MORE_BATCH_SIZE = 10;
const MAX_REPORT_ENTITIES = 500;

// ✅ UPDATED: Added description and is_derived to props
const ContentChart = React.forwardRef(
  ({ title, description = null, is_derived = false, datasets, previousdatasets = [], isLoading, entitlements, onConfigChange = () => { } }, ref) => { // [NEW] Added entitlements prop
    // Note: onConfigChange is kept in props for PropTypes but is now ignored internally.
    // State for filtering and sorting
    const [searchQuery, setSearchQuery] = useState("");
    const [sortOption, setSortOption] = useState("date");
    const [sortDirection, setSortDirection] = useState("desc");
    const [filterOption, setFilterOption] = useState("all");

    // Existing states
    const imageHeightsRef = useRef([]);
    const [heightCalculationDone, setHeightCalculationDone] = useState(false);
    const [entityDataReady, setEntityDataReady] = useState(false);
    const [allEntities, setAllEntities] = useState([]);
    const [renderCount, setRenderCount] = useState(INITIAL_RENDER_COUNT);
    const [loading, setLoading] = useState(false);

    // ✅ Details popup state
    const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
    const [selectedEntity, setSelectedEntity] = useState(null);

    // [NEW] Unlock Logic for "Discover & Organise"
    const [showUpgrade, setShowUpgrade] = useState(false);
    const FEATURE_KEY = "Discover & Organise";
    // Check if feature exists in entitlements. If no entitlements loaded yet, default to locked (or unlocked depending on your preference, usually locked for security)
    // Assuming if entitlements are missing/loading, we might want to default to TRUE (locked) or FALSE (open). 
    // Secure approach: Locked if not explicitly found.
    const isToolbarLocked = entitlements && entitlements.features ? !entitlements.features.includes(FEATURE_KEY) : true;
    const requiredPlan = entitlements?.requiredPlans?.[FEATURE_KEY] || "Higher Plan";

    // ✅ Handler to show analytics modal
    const handleViewAnalytics = (entity) => {
      setSelectedEntity(entity);
      setIsDetailsModalOpen(true);
    };
    const handleDetailsModalClose = () => {
      setIsDetailsModalOpen(false);
      setSelectedEntity(null);
    };

    const registerHeight = (height) => {
      imageHeightsRef.current.push(Math.round(height));
      if (imageHeightsRef.current.length === allEntities.length) {
        setHeightCalculationDone(true);
      }
    };

    const forcedHeight = useMemo(() => {
      if (!heightCalculationDone) return 250;
      const counts = {};
      imageHeightsRef.current.forEach((h) => {
        counts[h] = (counts[h] || 0) + 1;
      });
      const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1]);
      const MAX_ALLOWED_HEIGHT = 300;
      return sorted.length > 0 ? Math.min(Number(sorted[0][0]), MAX_ALLOWED_HEIGHT) : 250;
    }, [heightCalculationDone]);

    useEffect(() => {
      if (!datasets || datasets.length === 0) {
        setAllEntities([]);
        return;
      }

      setLoading(true);
      setHeightCalculationDone(false);
      setEntityDataReady(false);
      imageHeightsRef.current = [];
      setRenderCount(INITIAL_RENDER_COUNT);

      const entities = datasets.flatMap((profile) => {
        if (!profile) return []; // ✅ Guard for undefined profiles
        const contentField = profile.platform === "YouTube" ? "videos" : "posts";
        const entityType = profile.platform === "YouTube" ? "video" : "post";
        const contentArray = (profile.data || []).flatMap((entry) => entry[contentField] || []); // ✅ Guard for undefined data

        return contentArray.map((content) => ({
          ...content,
          profile,
          type: entityType,
        }));
      });

      setAllEntities(entities);
      setEntityDataReady(true);
      setTimeout(() => setHeightCalculationDone(true), 0);
      setLoading(false);
    }, [datasets]);

    const filteredAndSortedEntities = useMemo(() => {
      let tempEntities = [...allEntities];

      // Filtering Logic
      if (filterOption !== "all") {
        tempEntities = tempEntities.filter(
          (entity) =>
            entity.post_type === filterOption ||
            entity.video_type === filterOption ||
            entity.media_type === filterOption ||
            (!entity.post_type && !entity.video_type && !entity.media_type && entity.type === filterOption)
        );
      }

      // Search Logic
      if (searchQuery) {
        const lowercasedQuery = searchQuery.toLowerCase();
        tempEntities = tempEntities.filter((entity) => {
          const title = entity.title || entity.description || entity.caption || entity.message || "";
          return title.toLowerCase().includes(lowercasedQuery);
        });
      }

      // ✅ Restored helper functions
      const getReactionCount = (entity) => {
        if (entity.postMetrics) {
          return (
            (entity.postMetrics.like || entity.postMetrics.likes || 0) +
            (entity.postMetrics.love || 0) +
            (entity.postMetrics.wow || 0) +
            (entity.postMetrics.haha || 0) +
            (entity.postMetrics.sad || 0) +
            (entity.postMetrics.angry || 0)
          );
        }
        if (entity.videoMetrics) {
          return entity.videoMetrics.likeCount || 0;
        }
        return entity.like_count || 0;
      };

      const getTotalInteractionsCount = (entity) => {
        if (entity.postMetrics) {
          return (
            (entity.postMetrics.like || entity.postMetrics.likes || 0) +
            (entity.postMetrics.comments || 0) +
            (entity.postMetrics.shares || 0) +
            (entity.postMetrics.love || 0) +
            (entity.postMetrics.wow || 0) +
            (entity.postMetrics.haha || 0) +
            (entity.postMetrics.sad || 0) +
            (entity.postMetrics.angry || 0)
          );
        }
        if (entity.videoMetrics) {
          return (
            (entity.videoMetrics.likeCount || 0) +
            (entity.videoMetrics.commentCount || 0) +
            (entity.videoMetrics.viewCount || 0)
          );
        }
        return (
          (entity.like_count || 0) +
          (entity.comments_count || 0) +
          (entity.view_count || 0)
        );
      };

      const getFollowersByDate = (profileData, contentDate) => {

        // console.log("Profile Data : ", profileData);
        if (!profileData || profileData.length === 0) {
          return 1;
        }
        const contentTimestamp = new Date(contentDate).getTime();
        const closestEntry = profileData.reduce((closest, current) => {
          const currentTimestamp = new Date(current.date).getTime();
          const closestTimestamp = closest
            ? new Date(closest.date).getTime()
            : -Infinity;
          if (
            currentTimestamp <= contentTimestamp &&
            contentTimestamp - currentTimestamp <
            contentTimestamp - closestTimestamp
          ) {
            return current;
          }
          return closest;
        }, null);
        return closestEntry?.followers || closestEntry?.subscribers || closestEntry?.predicted_subscribers || closestEntry?.predicted_followers || 1;
      };

      // Sorting Logic
      if (tempEntities.length > 0) {
        const direction = sortDirection === "asc" ? 1 : -1;
        tempEntities.sort((a, b) => {
          let aValue, bValue;
          switch (sortOption) {
            case "date":
              aValue = new Date(a.created_time || a.publishedAt || a.taken_at || a.date || 0).getTime();
              bValue = new Date(b.created_time || b.publishedAt || b.taken_at || b.date || 0).getTime();
              break;
            case "reaction":
              aValue = getReactionCount(a);
              bValue = getReactionCount(b);
              break;
            case "engagement":
              // ✅ Updated to sort by Total Interactions (Absolute) instead of Rate
              const aTotalInteractions = getTotalInteractionsCount(a);
              const bTotalInteractions = getTotalInteractionsCount(b);
              aValue = aTotalInteractions;
              bValue = bTotalInteractions;
              break;
            case "engagement_rate":
              const aFollowersRate = getFollowersByDate(a.profile.data, a.created_time || a.publishedAt || a.taken_at || a.date);
              const bFollowersRate = getFollowersByDate(b.profile.data, b.created_time || b.publishedAt || b.taken_at || b.date);
              const aTotalInteractionsRate = getTotalInteractionsCount(a);
              const bTotalInteractionsRate = getTotalInteractionsCount(b);

              // Avoid division by zero
              aValue = aFollowersRate > 0 ? aTotalInteractionsRate / aFollowersRate : 0;
              bValue = bFollowersRate > 0 ? bTotalInteractionsRate / bFollowersRate : 0;
              break;
            default:
              return 0;
          }
          return (aValue - bValue) * direction;
        });
      }

      return tempEntities;
    }, [allEntities, searchQuery, filterOption, sortOption, sortDirection]);

    const filterOptions = useMemo(() => {
      const uniqueTypes = new Set();
      allEntities.forEach((entity) => {
        if (entity.post_type) uniqueTypes.add(entity.post_type);
        if (entity.video_type) uniqueTypes.add(entity.video_type);
        if (entity.media_type) uniqueTypes.add(entity.media_type);
        if (!entity.post_type && !entity.video_type && !entity.media_type) uniqueTypes.add(entity.type);
      });
      return ["all", ...Array.from(uniqueTypes)];
    }, [allEntities]);

    useEffect(() => {
      if (renderCount < filteredAndSortedEntities.length) {
        const timeout = setTimeout(() => {
          setRenderCount((prev) => Math.min(prev + LOAD_MORE_BATCH_SIZE, filteredAndSortedEntities.length));
        }, 500);
        return () => clearTimeout(timeout);
      }
    }, [renderCount, filteredAndSortedEntities.length]);

    const contentMetrics = useMemo(() => {
      if (!datasets) return []; // ✅ Guard
      const filteredCounts = {};
      filteredAndSortedEntities.forEach((entity) => {
        if (entity.profile) {
          const profileId = entity.profile.profileId;
          filteredCounts[profileId] = (filteredCounts[profileId] || 0) + 1;
        }
      });

      const previousFilteredEntities =
        previousdatasets
          ?.flatMap((profile) => {
            if (!profile) return [];
            const contentField = profile.platform === "YouTube" ? "videos" : "posts";
            return (profile.data || []).flatMap((entry) => entry[contentField] || [])
              .map((content) => ({ ...content, profile }))
              .filter((entity) => {
                if (filterOption === "all") return true;
                const entityType = entity.post_type || entity.video_type || (entity.profile.platform === "YouTube" ? "video" : "post");
                return entityType === filterOption;
              });
          }) || [];

      const previousFilteredCounts = {};
      previousFilteredEntities.forEach((entity) => {
        if (entity.profile) {
          const profileId = entity.profile.profileId;
          previousFilteredCounts[profileId] = (previousFilteredCounts[profileId] || 0) + 1;
        }
      });

      return datasets.map((profile) => {
        if (!profile) return null;
        const currentFilteredCount = filteredCounts[profile.profileId] || 0;
        const previousFilteredCount = previousFilteredCounts[profile.profileId] || 0;
        return {
          profilePic: profile.profilePictureUrl || "https://via.placeholder.com/150",
          name: profile.name || profile.label || "Unknown",
          platform: profile.platform,
          metricName: "Content Count",
          metricValue: currentFilteredCount.toLocaleString(),
          previousMetricValue: previousFilteredCount.toLocaleString(),
        };
      }).filter(Boolean);
    }, [datasets, previousdatasets, filteredAndSortedEntities, filterOption]);

    const rawChartConfig = useMemo(() => {
      const entityIdOrder = filteredAndSortedEntities
        .slice(0, MAX_REPORT_ENTITIES)
        .map(entity => entity.postId || entity.id || entity.videoId || entity.permalink_url);

      return { searchQuery, sortOption, sortDirection, filterOption, entityIdOrder };
    }, [filteredAndSortedEntities, searchQuery, sortOption, sortDirection, filterOption]);

    useImperativeHandle(ref, () => ({
      getCurrentConfig: () => rawChartConfig,
    }));

    // ⬇️=========================================
    // ⬇️ ADDED: Synthetic Chart Data for AI
    // ⬇️=========================================
    const aiChartData = useMemo(() => {
      if (!filteredAndSortedEntities || filteredAndSortedEntities.length === 0) return null;

      // Take the top 5 entities
      const topEntities = filteredAndSortedEntities.slice(0, 5);

      const labels = topEntities.map(e => {
        const title = e.title || e.description || e.caption || e.message || "Untitled";
        return title.length > 20 ? title.substring(0, 20) + "..." : title;
      });

      // We need a helper to get total interactions since it's defined inside useMemo
      // Duplicating the logic slightly for the AI data to be self-contained within this hook
      // OR better, we can assume they are sorted by what the user cares about? 
      // Actually, let's just use a simple "Total Interactions" sum here for the chart.

      const getData = (entity) => {
        // Simple Interaction Sum Logic
        if (entity.postMetrics) {
          return (entity.postMetrics.like || 0) + (entity.postMetrics.comments || 0) + (entity.postMetrics.shares || 0);
        }
        if (entity.videoMetrics) {
          return (entity.videoMetrics.likeCount || 0) + (entity.videoMetrics.commentCount || 0) + (entity.videoMetrics.viewCount || 0);
        }
        return (entity.like_count || 0) + (entity.comments_count || 0);
      };

      const data = topEntities.map(e => getData(e));

      // Create a single dataset "Top Content Engagement"
      const datasets = [{
        label: "Total Interactions",
        data: data,
        backgroundColor: "rgba(54, 162, 235, 0.6)"
      }];

      return { labels, datasets };
    }, [filteredAndSortedEntities]);

    // ⬇️=========================================
    // ⬇️ ADDED: Text Context for AI
    // ⬇️=========================================
    const aiContext = useMemo(() => {
      if (!filteredAndSortedEntities || filteredAndSortedEntities.length === 0) return "No content available.";

      const topEntities = filteredAndSortedEntities.slice(0, 10);
      let text = `Chart Description: Top Content Performance. This list shows the top performing content based on current filters (${filterOption}) and sort order (${sortOption} ${sortDirection}).\n\nTop 10 Items:`;

      topEntities.forEach((e, i) => {
        const title = e.title || e.description || e.caption || e.message || "Untitled";
        const platform = e.profile?.platform || "Unknown";
        const type = e.type || e.post_type || e.video_type || "content";

        // Re-calc metrics for context
        let interactions = 0;
        if (e.postMetrics) {
          interactions = (e.postMetrics.like || 0) + (e.postMetrics.comments || 0);
        } else if (e.videoMetrics) {
          interactions = (e.videoMetrics.likeCount || 0) + (e.videoMetrics.commentCount || 0);
        } else {
          interactions = (e.like_count || 0) + (e.comments_count || 0);
        }

        text += `\n${i + 1}. [${platform} ${type}] "${title.substring(0, 50)}...": ${interactions.toLocaleString()} interactions.`;
      });

      return text;
    }, [filteredAndSortedEntities, filterOption, sortOption, sortDirection]);


    if (isLoading) {
      return (
        <Card>
          <MDBox p={3} display="flex" justifyContent="center" alignItems="center" height="250px">
            <CircularProgress size={32} thickness={4} color="accent" />
          </MDBox>
        </Card>
      );
    }

    if (!datasets) {
      return (
        <Card>
          <MDBox p={3} textAlign="center">
            <MDTypography variant="body2" color="text">
              No data available.
            </MDTypography>
          </MDBox>
        </Card>
      );
    }

    // ⬇️ Tooltip for chart usage
    const tooltipContent = (
      <div style={{ maxWidth: "350px", textAlign: "left" }}>
        <Typography variant="body2" gutterBottom>
          <strong>Description:</strong>
        </Typography>
        <Typography variant="caption" display="block" gutterBottom>
          This component displays all individual content (posts and videos) published by the selected profiles within the chosen date range.
        </Typography>

        <Typography variant="body2" gutterBottom>
          <strong>How to use this chart:</strong>
        </Typography>
        <Typography variant="caption" display="block" gutterBottom>
          - Use the toolbar to filter by content type, sort by date or engagement, or search for specific keywords. <br />
          - Click the analytics icon on any post to view its detailed performance metrics.
        </Typography>

        <Typography variant="body2" gutterBottom>
          <strong>Insights you can gain:</strong>
        </Typography>
        <Typography variant="caption" display="block">
          - Visually compare the content being posted by different profiles. <br />
          - Sort by "Engagement" to quickly find the top-performing content. <br />
          - Filter by "video" or "photo" to analyze a specific content strategy.
        </Typography>
      </div>
    );

    return (
      <>
        <Card sx={{ display: "flex", flexDirection: "column" }}>
          <ChartHeader
            title={title}
            description={description || tooltipContent}
            profilePictures={contentMetrics.map(m => m.profilePic)}
            is_derived={is_derived}
          >
            {/* ✅ AI Assistant */}
            <ChartAssistant
              title={title}
              context={aiContext}
              chartData={aiChartData}
              rawData={filteredAndSortedEntities.slice(0, 20)} // Pass top 20 raw items
              sx={{
                position: "static",
                boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                ml: 2
              }}
              entitlements={entitlements} // ✅ Pass entitlements
            />
          </ChartHeader>

          <ContentToolbar
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            sortOption={sortOption}
            setSortOption={setSortOption}
            sortDirection={sortDirection}
            setSortDirection={setSortDirection}
            filterOption={filterOption}
            setFilterOption={setFilterOption}
            filterOptions={filterOptions}
            isLocked={isToolbarLocked}  // [NEW] Pass derived lock state
            onUpgrade={() => setShowUpgrade(true)} // [NEW] Pass upgrade handler
          />

          <MetricCardsContainer metrics={contentMetrics} />
          <MDBox mt={1} />

          <MDBox px={2} py={3} sx={{ flexGrow: 1, overflowY: "auto", maxHeight: "700px" }}>
            {loading || !entityDataReady ? (
              <MDBox display="flex" justifyContent="center" alignItems="center" p={3}>
                <CircularProgress color="accent" />
              </MDBox>
            ) : filteredAndSortedEntities.length === 0 ? (
              <MDTypography variant="subtitle1" color="text" align="center">
                No content found for this filter.
              </MDTypography>
            ) : (
              <MDBox display="flex" flexWrap="wrap" justifyContent="center" gap={2} px={2}>
                {filteredAndSortedEntities.slice(0, renderCount).map((entity, index) => {
                  const id = entity.postId || entity.videoId || entity.id || `content-${index}`;
                  return (
                    <Grow in={true} timeout={index * 50} key={id} style={{ transformOrigin: "0 0 0" }}>
                      <div>
                        <MDBox sx={{ flex: "1 1 calc(20% - 16px)", minWidth: "280px", maxWidth: "300px" }}>
                          <EntityCard
                            entityObject={entity}
                            platform={entity.profile.platform}
                            entityType={entity.type}
                            profileObject={entity.profile}
                            isSelected={false}
                            onSelect={() => { }}
                            forcedHeight={forcedHeight}
                            registerHeight={registerHeight}
                            onViewAnalytics={() => handleViewAnalytics(entity)}
                          />
                        </MDBox>
                      </div>
                    </Grow>
                  );
                })}
              </MDBox>
            )}
          </MDBox>

          {/* Disclaimer Footer */}
          {is_derived && (
            <MDBox p={1} display="flex" justifyContent="flex-end">
              <MDTypography
                variant="caption"
                color="text"
                sx={{
                  fontStyle: "italic",
                  fontSize: "0.7rem",
                  opacity: 0.7,
                  mr: 1
                }}
              >
                *Metric calculated by Comparedly
              </MDTypography>
            </MDBox>
          )}
        </Card>

        {isDetailsModalOpen && selectedEntity && (
          <EntityDetailsPopup
            isModalOpen={isDetailsModalOpen}
            onClose={handleDetailsModalClose}
            entityObject={selectedEntity}
          />
        )}

        {/* 🔒 [NEW] Upgrade Popup */}
        <UpgradePopup
          open={showUpgrade}
          onClose={() => setShowUpgrade(false)}
          featureName={FEATURE_KEY}
          planRequired={requiredPlan}
        />
      </>
    );
  }
);

ContentChart.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.node,
  is_derived: PropTypes.bool,
  datasets: PropTypes.array.isRequired,
  previousdatasets: PropTypes.array,
  isLoading: PropTypes.bool.isRequired,
  onConfigChange: PropTypes.func,
  entitlements: PropTypes.object, // [NEW] Added propType
};

export default ContentChart;